module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4984a14327d6912c79d89b58bfdd061b.png";